import { ChangeDetectionStrategy, Component } from '@angular/core';
import { fromEvent, takeUntil } from 'rxjs';
import { BaseObject } from '@shared/base/base-object';
import { SeoService } from '@shared/helpers/seo.service';
import { VersionService } from '@shared/helpers/version.service';
import { SettingsState, SiteName } from '@shared/states/settings.state';
import { UserState } from '@shared/states/user.state';
import { LanguageCodes } from '@shared/translates/language';
import { TranslateService } from '@shared/translates/translate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent extends BaseObject {
  constructor(
    private versionService: VersionService,
    public userState: UserState,
    private settingsState: SettingsState,
    private translateService: TranslateService,
    private seoService: SeoService,
  ) {
    super();

    this.versionService.start();

    this.updateClipboardTextOnCopy();

    if (this.settingsState.siteName === SiteName.Preprod) {
      this.listenToLangSwitch();
    }
  }

  private updateClipboardTextOnCopy(): void {
    fromEvent(document, 'copy')
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: ClipboardEvent) => {
        const selection = document.getSelection();

        if (selection.type === 'Range') {
          event.preventDefault();
          const copyTextCorrected = selection.toString().trim();
          event.clipboardData.setData('text/plain', copyTextCorrected);
        }
      });
  }

  private listenToLangSwitch(): void {
    fromEvent(document, 'keydown')
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: KeyboardEvent) => {
        if (event.shiftKey) {
          switch (event.code) {
            case 'F1':
              this.translateService.setLanguage(LanguageCodes.en).subscribe(() => {
                this.seoService.setLanguage(this.translateService.currentLanguage);
              });
              break;

            case 'F2':
              this.translateService.setLanguage(LanguageCodes.hy).subscribe(() => {
                this.seoService.setLanguage(this.translateService.currentLanguage);
              });
              break;
          }
        }
      });
  }
}
